export default function PHP_number_format() {
  return (
    <div>
      <h1>PHP_number_format</h1>
    </div>
  );
}
